// extracted by mini-css-extract-plugin
export default {"group":"zxbH1HYf","mobile":"mobile","content":"v99EHsA6"};